import {
   Details,
   FormValues,
   Item,
   SelectedItems,
   Stage,
} from "../types/productTypes";
import { findItemByOptionAndName } from "./findItem";

export const calculateTotalPrice = (
   _allValues: FormValues,
   _stages: Stage[] | undefined,
   initialPrice: number | undefined
) => {
   if (!initialPrice) return 0;

   return initialPrice;
};

export const calculateTotalPriceLegacy = (
   allValues: FormValues,
   stages: Stage[] | undefined,
   initialPrice: number | undefined
) => {
   if (!initialPrice) return 0;
   if (!stages) return initialPrice;
   const reducer = (
      totalPrice: number,
      [key, value]: [string, SelectedItems | Details]
   ): number => {
      if (Array.isArray(value)) {
         return value.reduce(
            (subtotal, itemValue) => reducer(subtotal, [key, itemValue]),
            totalPrice
         );
      } else if ("selectedItem" in value && value.selected) {
         // Handle SelectedItems
         const selectedItem = value.selectedItem;

         if (Array.isArray(selectedItem)) {
            return selectedItem.reduce((subtotal, id) => {
               const item = findItemByOptionAndName(key, id, stages);
               if (!item) return subtotal;

               // Determine the correct price based on dependencies

               let finalPrice = getAdjustedPrice(item, allValues);
               if (!finalPrice) finalPrice = 0;
               return subtotal + finalPrice;
            }, totalPrice);
         } else {
            const item = findItemByOptionAndName(key, selectedItem, stages);
            if (!item) return totalPrice;

            let finalPrice = getAdjustedPrice(item, allValues);
            if (!finalPrice) finalPrice = 0;

            return totalPrice + finalPrice;
         }
      }
      return totalPrice; // If it's not a SelectedItem, return
      // accumulated total
   };

   return Object.entries(allValues).reduce(reducer, initialPrice);
};
export const getAdjustedPrice = (item: Item, allValues: FormValues) => {
   if (!item.dependentDependencyManager.length) {
      return item.price; // No dependencies, return the item's base price
   }

   // Check which dependent item is selected in `allValues`
   for (const dependency of item.dependentDependencyManager) {
      if (!dependency.priceDependency) continue;
      const dependentItemSelected = Object.values(allValues).some(
         (val) =>
            "selectedItem" in val &&
            val.selected &&
            (Array.isArray(val.selectedItem)
               ? dependency.affectingItemId?.toString() &&
                 val.selectedItem.includes(
                    dependency.affectingItemId?.toString()
                 )
               : val.selectedItem === dependency.affectingItemId?.toString())
      );

      if (dependentItemSelected) {
         return dependency.priceDependency?.priceAdjustment; // Return the matching priceAdjustment
      }
   }

   return item.price; // If no dependencies are selected, fallback to base price
};
